__webpack_require__.p = "/bouldering/";